import { DateService } from "@topline/services/dateService";
import { ToasterService } from "@topline/services/toasterService";
(function (module) {
    "use strict";

    module.component('marketExport', {
        template: require('./marketExportComponent.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: ['initializeReportHubService', '$http', '$q', ToasterService.componentName, DateService.componentName, function(
            this: $TSFixMe,
            initializeReportHubService: $TSFixMe,
            $http: ng.IHttpService,
            $q: ng.IQService,
            toasterService: ToasterService,
            dateService: DateService
        ) {
            var $ctrl = this;
            $ctrl.$onInit = function () {
                $ctrl.options = {
                    datepickerMode: 'year',
                    minMode: 'year',
                    initDate: dateService.getDefaultBudgetYearDate()
                }
                $ctrl.status = 'forecastUsedInAcceptedMarkets';
            };
            $ctrl.ok = function () {
                const marketContentReportGenerationIsFinished = initializeReportHubService.getMarketContentReportGenerationIsFinished();

                if (marketContentReportGenerationIsFinished) {
                    const result = $http.post("/api/report/market/content-prepare", {
                            year: ($ctrl.year ? $ctrl.year : dateService.getDefaultBudgetYearDate()).getFullYear(),
                            status: $ctrl.status
                        })
                        .then(function resolved(response: $TSFixMe) {
                            if (response.status === 200) {
                                return true;
                            }
                            toasterService.info('MARKET.GENERATING_MARKET_REPORT_ERROR');
                            return $q.reject('error in market generating');
                        }, function rejected() {
                            return false;
                        });
                    if (!result) {
                        initializeReportHubService.marketContentReportGenerationFailed();
                    }
                }
                $ctrl.close();
            };

            $ctrl.cancel = function () {
                $ctrl.dismiss({
                    $value: 'cancel'
                });
            };
        }]
    })

})(angular.module('topline.modules'));